import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  cancelDownload,
  fetchDownloadFile,
  fetchDownloadList,
  reset,
  setPage,
} from 'features/bulk/download/downloadSlice'
import Pagination from 'components/pagination/Pagination'
import Button from 'components/form/Button'
import { dateformat } from 'utils'
import Table from 'components/table/Table'
import NoneAnchor from 'components/NoneAnchor'
import Moment from 'react-moment'
import { fail } from 'features/toast/Toast'
import { BULK_STATUS } from 'features/bulk/BulkCodes'
import {
  hideDownloadModal,
  showDownloadModal,
} from 'features/bulk/download/downloadModalSlice'
import DownloadModal from './DownloadModal'
import { useAlert } from 'features/dialog/Alert'

const Download = () => {
  const dispatch = useDispatch()
  const {
    isLoading,
    content,
    totalElements,
    page,
    size,
    disabledCancel,
    disabledDownload,
  } = useSelector(state => state.bulk.download)
  const [FailedAlert, showFailedAlert] = useAlert()

  useEffect(() => {
    dispatch(fetchDownloadList())
  }, [dispatch, page])

  useEffect(
    () => () => {
      dispatch(reset())
      dispatch(hideDownloadModal())
    },
    [dispatch]
  )

  const showModal = () => {
    dispatch(showDownloadModal())
  }

  const handleRefresh = () => {
    dispatch(fetchDownloadList())
  }

  const handlePageChange = v => dispatch(setPage(v))

  const handleCancelDownload = async id => {
    const { error, payload } = await dispatch(cancelDownload(id))
    if (error) {
      fail(payload.errorMessage)
    }
    dispatch(fetchDownloadList())
  }

  const handleFileDownload = async id => {
    const { error, payload } = await dispatch(fetchDownloadFile(id))
    if (error) {
      fail(payload.errorMessage)
    } else {
      window.open(`${payload.url}&download`)
    }
  }

  return (
    <>
      <ul className="list_append">
        <li>
          다운로드 메뉴를 통해 캠페인, 광고그룹, 키워드 등의 정보와 등록된
          소재를 CSV 형식 파일로 대량 다운로드할 수 있습니다.
        </li>
        <li>
          대량 관리를 통한 작업 시간은 사용량과 데이터 크기에 따라 유동적일 수
          있으며, 대량 관리 내역은 최근 3개월까지만 제공합니다.
        </li>
      </ul>
      <div className="ad_managebox">
        <div className="managebox_tit">
          <strong className="tit_box">
            총 다운로드 목록 <em className="fc_emph">{totalElements}</em>
          </strong>
          <div className="f_left">
            <Button primary onClick={showModal}>
              <span className="img_comm ico_add" />
              다운로드 등록하기
            </Button>
          </div>
          <div className="f_right">
            <Button line onClick={handleRefresh} disabled={isLoading}>
              새로고침
            </Button>
          </div>
        </div>
        <div className="tblg2_wrap">
          <Table
            className="tbl_g2"
            caption="다운로드 목록 표"
            loading={isLoading}
            emptyMessage={
              <>
                등록된 다운로드 목록이 없습니다.
                <br />
                <NoneAnchor className="link_txt" onClick={showModal}>
                  다운로드 등록하기
                </NoneAnchor>
                를 클릭하여 새로운 다운로드 유형을 생성하세요.
              </>
            }>
            <Table.Head>
              <Table.Column title="등록일시" width={153} />
              <Table.Column title="유형" width={157} />
              <Table.Column title="작업명" />
              <Table.Column title="처리자" width={249} />
              <Table.Column title="상태" width={130} />
              <Table.Column title="완료일시" width={145} />
              <Table.Column title="처리결과" width={85} className="align_c" />
            </Table.Head>
            <Table.Body>
              {content.map(
                ({
                  id,
                  name,
                  actor,
                  type,
                  status,
                  createdDate,
                  processedDate,
                }) => (
                  <Table.Row key={id} rowId={id}>
                    <td>
                      <div className="inner_tbl">
                        <Moment format={dateformat}>{createdDate}</Moment>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {type === 'CREATIVE' ? '광고소재 관리' : '캠페인'}
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <span className="limit_line">{name}</span>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">{actor}</div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <p className="ad_state">
                          <span className={`ico_${BULK_STATUS[status].icon}`}>
                            DOWNLOAD_STATUS[status].icon
                          </span>
                          {BULK_STATUS[status].text}
                          {status === BULK_STATUS.WAITING.name && (
                            <Button
                              line
                              size="small"
                              disabled={disabledCancel}
                              onClick={() => handleCancelDownload(id)}>
                              취소
                            </Button>
                          )}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        {processedDate && (
                          <Moment format={dateformat}>{processedDate}</Moment>
                        )}
                      </div>
                    </td>
                    <td className="align_c">
                      <div className="inner_tbl">
                        <div className="wrap_btn">
                          {(status === BULK_STATUS.PROCESSED.name ||
                            status === BULK_STATUS.PARTIAL_FAILED.name) && (
                            <Button
                              size="small"
                              disabled={disabledDownload}
                              onClick={() => {
                                handleFileDownload(id)
                              }}>
                              다운로드
                            </Button>
                          )}
                          {status === BULK_STATUS.TOTAL_FAILED.name && (
                            <Button size="small" onClick={showFailedAlert}>
                              내역보기
                            </Button>
                          )}
                        </div>
                      </div>
                    </td>
                  </Table.Row>
                )
              )}
            </Table.Body>
          </Table>
        </div>
        {totalElements > 0 && (
          <div className="paging_wrap">
            <div className="inner_paging">
              <Pagination
                current={page}
                total={totalElements}
                size={size}
                onChange={handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
      <DownloadModal />
      <FailedAlert title="실패 내역 보기">
        시스템 이슈로 파일 다운로드가 실패하였습니다.
        <br />
        다운로드 등록하기를 통해 재요청 바랍니다.
      </FailedAlert>
    </>
  )
}
export default Download
